export default __webpack_public_path__ + "static/media/DJI_0971.MP4.00_04_24_08.Still002.7aae2a7a.jpg";